import { render, staticRenderFns } from "./desk.vue?vue&type=template&id=75eb5554&scoped=true"
import script from "./desk.vue?vue&type=script&lang=js"
export * from "./desk.vue?vue&type=script&lang=js"
import style0 from "./desk.vue?vue&type=style&index=0&id=75eb5554&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75eb5554",
  null
  
)

export default component.exports